import { createContext, useContext, useState, useEffect } from 'react';
import { adminApi } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    // Check both localStorage and sessionStorage
    const token = localStorage.getItem('admin_token') || sessionStorage.getItem('admin_token');
    if (token) {
      // Ensure token is in localStorage for API calls
      if (!localStorage.getItem('admin_token')) {
        localStorage.setItem('admin_token', token);
      }
      try {
        const response = await adminApi.getMe();
        setAdmin(response.data);
      } catch (error) {
        localStorage.removeItem('admin_token');
        sessionStorage.removeItem('admin_token');
      }
    }
    setLoading(false);
  };

  const login = async (email, password, rememberMe = false) => {
    const response = await adminApi.login({ email, password });
    const token = response.data.access_token;
    
    // Store token based on remember me preference
    if (rememberMe) {
      localStorage.setItem('admin_token', token);
    } else {
      sessionStorage.setItem('admin_token', token);
      localStorage.setItem('admin_token', token); // Also store in localStorage for API calls
    }
    
    await checkAuth();
    return response.data;
  };

  const logout = async () => {
    try {
      await adminApi.logout();
    } catch (error) {
      // Ignore logout API errors
    }
    localStorage.removeItem('admin_token');
    sessionStorage.removeItem('admin_token');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
